import { render, staticRenderFns } from "./SchematronsPanel.vue?vue&type=template&id=eaba9090&scoped=true&"
import script from "./SchematronsPanel.vue?vue&type=script&lang=js&"
export * from "./SchematronsPanel.vue?vue&type=script&lang=js&"
import style0 from "./SchematronsPanel.vue?vue&type=style&index=0&id=eaba9090&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaba9090",
  null
  
)

export default component.exports